import { useEffect, useRef, useState } from "react";
import { Spinner100, DeliverLicenseIcon, NoDeliverLicenseIcon } from "../../../components/icons/SvgIcons";
import { useDispatch, useSelector } from "react-redux";
import { getInfoEgreso, postEgresoLicencia } from "../../../redux/actions";
import { useForm } from "react-hook-form";
import SignatureCanvas from "react-signature-canvas";
import ErrorModal from "../../../components/modals/errorModal";
import SuccessModal from "../../../components/modals/successModal";

function EgresarLicenciaComponent({
  dni,
  closeModalEgresoLicencia,
  observaciones,
  id,
  onLicenciaActualizada,
}) {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const userId = useSelector((state) => state.currentUserId);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const firmaRef = useRef(null);

  const onSubmit = async (data, event) => {
    event.preventDefault();

    if (firmaRef.current.isEmpty()) {
      setError("firma", {
        type: "manual",
        message: "Por favor, complete la firma",
      });
      return;
    }

    setLoading(true);

    data.userId = userId;
    data.licencia_id = id;

    const firmaDataUrl = firmaRef.current.toDataURL("image/png");

    const blob = await fetch(firmaDataUrl).then((res) => res.blob());

    const formData = new FormData();

    for (const key in data) {
      if (key !== "firma") {
        formData.append(key, data[key]);
      }
    }

    formData.append("firma", blob, "firma.png");

    try {
      await dispatch(postEgresoLicencia(formData));
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error al egresar la licencia:", error);
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    onLicenciaActualizada();
    closeModalEgresoLicencia();
  };

  const closeErrorModal = () => {
    setShowErrorModal(false);
  };

  //-----------Firma--------------//

  const limpiarFirma = () => {
    firmaRef.current.clear();
  };

  const [infoEgreso, setInfoEgreso] = useState({});

  useEffect(() => {
    const fetchInfoEgreso = async () => {
      const resp = await dispatch(getInfoEgreso(dni));

      setInfoEgreso(resp);
    };

    fetchInfoEgreso();
  }, [dispatch, dni]);

  const { state, msg } = infoEgreso || { "state": "Habilitado", "msg": "" };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 overflow-y-auto"
      onClick={closeModalEgresoLicencia} /* Cierra al hacer clic fuera */
    >
      <div
        className="relative flex flex-col gap-2 bg-[#F5FAFF] rounded-[8px] border p-4 w-[20rem] sm:w-[32rem]"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <button
          onClick={closeModalEgresoLicencia}
          className="absolute top-1 right-2 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
        <div className="sm:gap-4 bg-white rounded-[8px] border border-[#61ABCF] divide-y divide-[#61ABCF]">
          <div className="flex flex-col py-1 px-4 gap-5">
            <dt className="text-sm/6 font-bold text-[#036395] font-inter">
              INFORMACION DE JUZGADO:
            </dt>
          </div>
          {infoEgreso ? (
            <div>
              <div className="flex flex-col py-1 grid-cols-2 px-4 gap-1">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Estado:
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700  sm:mt-0">


                  {state === "Habilitado" ? (
                    <div className="flex justify-start p-1.5 bg-[#ccf8dd] rounded-xl items-center gap-1">
                      <div className="text-[#0d6e34] text-l font-semibold font-inter">
                        Entregar licencia
                      </div>
                      <div className="w-8 h-8 relative overflow-hidden">
                        <div className="w-[24.75px] h-6 left-[4px] top-[5px] absolute">
                          <DeliverLicenseIcon className="size-6" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-start p-1.5 bg-[#fed5d5] rounded-xl items-center gap-1">
                      <div className="text-[#a21414] text-l font-semibold font-inter">
                        No entregar licencia
                      </div>
                      <div className="w-8 h-8 relative overflow-hidden">
                        <div className="w-[24.75px] h-6 left-[4px] top-[5px] absolute">
                          <NoDeliverLicenseIcon className="size-6" />
                        </div>
                      </div>
                    </div>
                  )}
                </dd>
              </div>
              <div className="flex flex-col py-1 grid-cols-2 px-4 gap-2">
                <dt className="text-sm/6 font-medium text-gray-900">Mensaje:</dt>
                <dd className="mt-1 text-sm/6 text-gray-700  sm:mt-0">
                  {msg}
                </dd>
              </div>
            </div>)
            :
            (
              <div className="flex flex-col py-2  px-4 gap-2">
                <dt className=" text-sm/6 font-bold text-[#036395] font-inter">
                  No hay información de juzgado sobre esta licencia, la entrega queda a criterio de corralón
                </dt>

              </div>
            )}

        </div>


        {observaciones ? (
          <div className="sm:gap-1 bg-white rounded-[8px]  border border-[#61ABCF] divide-y divide-[#61ABCF]">
            <div className="flex flex-col py-1  px-4 gap-5">
              <dt className=" text-sm/6 font-bold text-[#036395] font-inter">
                OBSERVACIÓN DE INGRESO
              </dt>
            </div>
            <div className="flex flex-col py-1  px-4 gap-2">
              <dt className="text-sm/6 font-medium text-gray-900">
                {observaciones}
              </dt>

            </div>
          </div>) : (null)}



        {state === "Habilitado" ? (

          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Contenido principal */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2">
              {/* Campo Fecha y hora de salida */}
              <div className="self-stretch flex justify-start items-start gap-1 sm:flex-row flex-col">
                <div className="flex-grow flex flex-col justify-start items-start gap-1 w-full">
                  <label className="text-[#3d4245] text-sm font-normal font-inter">
                    Fecha y hora de entrega
                  </label>
                  <div className="flex items-center gap-1 w-full">
                    <input
                      name="fecha_hora"
                      placeholder="0"
                      type="datetime-local"
                      defaultValue={(() => {
                        const ahora = new Date();

                        const ahoraArgentina = new Date(
                          ahora.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })
                        );

                        const pad = (n) => n.toString().padStart(2, "0");

                        const year = ahoraArgentina.getFullYear();
                        const month = pad(ahoraArgentina.getMonth() + 1);
                        const day = pad(ahoraArgentina.getDate());
                        const hour = pad(ahoraArgentina.getHours());
                        const minute = pad(ahoraArgentina.getMinutes());

                        return `${year}-${month}-${day}T${hour}:${minute}`;
                      })()}
                      className="self-stretch  p-2 rounded-md border border-[#687073] text-sm font-normal font-inter w-full flex-grow"
                      {...register("fecha_hora", {
                        required: "Por favor, ingrese la fecha y hora.",
                        validate: (value) => {
                          const selectedDate = new Date(value);
                          const now = new Date();
                          const threeYearsAgo = new Date();
                          threeYearsAgo.setFullYear(now.getFullYear() - 3);

                          if (selectedDate > now) {
                            return "La fecha no puede ser superior a la actual";
                          }
                          if (selectedDate < threeYearsAgo) {
                            return `El año no puede ser menor a ${threeYearsAgo.getFullYear() + 1
                              }`;
                          }
                          return true; // La fecha es válida
                        },
                      })}
                    />
                  </div>
                </div>
              </div>

              {/* Firma */}
              <div className="self-stretch flex flex-col gap-1 justify-start items-start">
                <label className="text-[#3d4245] text-sm font-normal font-inter">
                  Firma
                </label>
                <SignatureCanvas
                  ref={firmaRef}
                  penColor="blue"
                  onBegin={() => clearErrors("firma")} // Limpia el error al comenzar a firmar
                  canvasProps={{
                    height: 150,
                    className: "border border-black rounded-md w-full bg-white",
                  }}
                />
                <div className="flex gap-1">
                  <button
                    type="button"
                    onClick={limpiarFirma}
                    className="bg-gray-300 px-4 py-2 rounded-md"
                  >
                    Limpiar
                  </button>
                </div>
              </div>

              {/* Mensajes de error */}
              <div className=" text-start">
                {Object.values(errors).map((error, index) => (
                  <p className="text-red-500 " key={index}>
                    {error.message}
                  </p>
                ))}
              </div>

              {/* Botones */}
              <div className="self-stretch flex justify-start items-start gap-3 sm:flex-row flex-col">
                <button
                  type="submit"
                  className="w-full h-[50px] px-[18px] py-[13px] bg-[#0477ad] rounded-lg flex justify-center items-center gap-1 flex-grow"
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner100 className="w-6 h-6 text-[#0477ad] animate-spin fill-white" />
                  ) : (
                    <div className="text-[#f6f5f5] text-base font-semibold font-inter">
                      Egresar licencia
                    </div>
                  )}
                </button>
                <button
                  type="button"
                  onClick={closeModalEgresoLicencia}
                  className="w-full flex-grow h-[50px] px-[18px] py-[13px] bg-white rounded-lg border border-[#0477ad] flex justify-center items-center gap-1 "
                >
                  <div className="text-[#0477ad] text-base font-semibold font-inter">
                    Cancelar
                  </div>
                </button>
              </div>
            </div>
          </form>
        ) : (
          <button
            type="button"
            onClick={closeModalEgresoLicencia}
            class=" h-[45px] px-[4px] py-[6px] bg-[#0477AD] rounded-[8px] overflow-hidden justify-center items-center flex text-[#F6F5F5] text-[16px] font-inter font-semibold gap-[4px]"
          >
            Cerrar
          </button>
        )}

      </div>
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
          message="Licencia egresada con éxito"
        />
      )}
      {showErrorModal && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message="Hubo un error al egresar la licencia"
        />
      )}
    </div>
  );
}

export default EgresarLicenciaComponent;
